

















import {Vue, Component, Prop, Watch, Model} from 'vue-property-decorator';
import {getToday, getStrDate, changeDateFormat} from '@/utils/dateUtils';
import TuiDatePicker from 'tui-date-picker';
import RootElement from '@/components/common/RootElement.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import moment from 'moment'

@Component({
  components: {RootElement, CompSelectBox}
})
export default class DateCalendar extends Vue {
  @Prop({default: 'span'})
  private tag!: string;

  @Prop() private option?: any;
  private calendarInfo: any = {
    dateType: 'Ymd',
    placeholder: '',
    endDate: false,
    name: 'calendar',
    fromRanges: '1900-01-01',
    toRanges: '2999-12-31',
    topContainer: false,
    endDatePositiveOrder: false,
    detailTime: false,
  };
  private initCalendarOver = false;

  @Prop() private disabled?: boolean;
  @Prop() private isImutableRendering?: boolean;
  private constantYmd!: string;
  private constantHms!: string;
  private setConstValueAfterMounting() {
    if (!this.isImutableRendering) return;

    const tempDate = this.constantYmd + ' ' + this.constantHms;
    this.selecdYmd = this.constantYmd;
    this.selecdHms = this.constantHms;
    this.selectedHour = changeDateFormat(tempDate, 'HH');
    this.selectedMinute = changeDateFormat(tempDate, 'mm:ss');
  }

  private selecdYmd: string = '';
  private selectDatepicker: any;
  private selecdHms: string = '00:00:00';
  private selectedHour: string = '00';
  private selectedMinute: string = '00:00';

  private get hList() {
    let hList = [];
    if (this.calendarInfo.detailTime) {
      for (let i = 0; i <= 23; i++) {
        let tempH = i < 10 ? '0' + i : i.toString();
        let item = {
          value: tempH,
          name: tempH
        };
        hList.push(item);
      }
      return hList;
    }
    if (this.calendarInfo.endDate) {
      if (this.calendarInfo.endDatePositiveOrder) {
        for (let i = 0; i <= 23; i++) {
          let tempH = i < 10 ? '0' + i : i.toString();
          let item = {
            value: tempH + ':59:59',
            name: tempH
          };
          if (this.calendarInfo.dateType === 'YmdHm') {
            item.name += ':59';
          }
          hList.push(item);
        }
      } else {
        for (let i = 23; i >= 0; i--) {
          let tempH = i < 10 ? '0' + i : i.toString();
          let item = {
            value: tempH + ':59:59',
            name: tempH
          };
          if (this.calendarInfo.dateType === 'YmdHm') {
            item.name += ':59';
          }
          hList.push(item);
        }
      }
    } else {
      for (let i = 0; i < 24; i++) {
        let tempH = i < 10 ? '0' + i : i.toString();
        let item = {
          value: tempH + ':00:00',
          name: tempH
        };
        if (this.calendarInfo.dateType === 'YmdHm') {
          item.name += ':00';
        }
        hList.push(item);
      }
    }
    return hList;
  }

  private get mList() {
    let mList = [];
    for (let i = 0; i < 60; i++) {
      let tempH = i < 10 ? '0' + i : i.toString();
      let item = {
        value: tempH + (this.calendarInfo.endDate ? ':59' : ':00'),
        name: tempH,
      };
      mList.push(item);
    }
    return mList;
  }

  @Model('change') readonly value!: any;
  @Watch('value', {immediate: true, deep: false})
  onValueChanged(next: string) {
    if (next === '' || next === null || next === undefined) {
      this.selecdYmd = '';
      this.selectDatepicker.setDate(new Date(''));
      if (this.calendarInfo.endDate) {
        this.selecdHms = '23:59:59';
      } else {
        this.selecdHms = '00:00:00';
      }
    } else {
      let nextDate = new Date(next);
      if (nextDate instanceof Date && !isNaN(nextDate.getTime())) {
        let tempYmd = changeDateFormat(next, 'YYYY-MM-DD');
        let tempTime = changeDateFormat(next, 'HH:mm:ss');
        this.selecdYmd = tempYmd;
        if (this.selectDatepicker) {
          this.selectDatepicker.setDate(new Date(tempYmd));
        }
        this.selecdHms = tempTime;
        this.selectedHour = changeDateFormat(next, 'HH');
        this.selectedMinute = changeDateFormat(next, 'mm:ss');
      }
    }
  }
  @Watch('selecdYmd', {immediate: false, deep: false})
  wSelecdYmd(next: string) {
    this.changeYmdt(next, this.selecdHms);
  }
  @Watch('selecdHms', {immediate: false, deep: false})
  wSelecdHms(next: string) { // next: 'HH:mm:ss'
    let changeed = true;
    if (typeof this.calendarInfo.checkDate === 'function') {
      changeed = this.calendarInfo.checkDate(this.selecdYmd + ' ' + next);
    }
    if (changeed) {
      this.wSelectedHour(next.slice(0, 2)); // 'HH'
      this.wSelectedMinute(next.slice(3)); // 'mm:ss'
      this.changeYmdt(this.selecdYmd, next);
    } else {
      this.$nextTick(() => {
        this.selecdHms = changeDateFormat(this.value, 'HH:mm:ss');
      });
    }
  }
  @Watch('selectedHour', {immediate: false, deep: false})
  private wSelectedHour(next: string) { // next: 'HH'
    const newTime = next + this.selecdHms.slice(2); // 'HH' + ':mm:ss'
    this.changeYmdt(this.selecdYmd, newTime);
  }
  @Watch('selectedMinute', {immediate: false, deep: false})
  private wSelectedMinute(next: string) { // next: 'mm:ss'
    const newTime = this.selecdHms.slice(0, 3) + next; // 'HH:' + 'mm:ss'
    this.changeYmdt(this.selecdYmd, newTime);
  }

  @Watch('option.fromRanges')
  private setRangesOption(): void {
    this.calendarInfo.fromRanges = this.option.fromRanges;

    if (!this.selectDatepicker) return;
    const dateRanges: [Date, Date][] = [
      [moment(this.calendarInfo.fromRanges).toDate(), moment(this.calendarInfo.toRanges).toDate()],
    ];
    this.selectDatepicker.setRanges(dateRanges);
  }
  changeYmdt(ymd: string, hms: string) {
    let ymdt = '';
    if (this.calendarInfo.dateType === 'YmdH' || this.calendarInfo.dateType === 'YmdHm') {
      ymdt = ymd + ' ' + hms;
    } else {
      ymdt = ymd;
    }

    const oldValue = this.value
	  this.$emit('change:before', oldValue)
    this.$emit('change', ymdt);
  }

  private onClickToday(e: any) {
    const targetWrap = $(e.target).parents('.date-picker_wrap');
    const targetPickerId = targetWrap.find('input.date-picker').attr('id');
    if (targetPickerId === `selecdYmd_${this.calendarInfo.name}`) {
      let changeed = true;
      if (typeof this.calendarInfo.checkDate === 'function') {
        changeed = this.calendarInfo.checkDate(getToday() + ' ' + this.selecdHms);
      }
      if (changeed) {
        this.selecdYmd = getToday();
        this.selectDatepicker.setDate(new Date());
      }
    }
  }

  private async initOption() {
    if (this.option) {
      Object.assign(this.calendarInfo, this.option);
    }
    this.initCalendarOver = true;
  }
  private created() {
    if (this.isImutableRendering) {
      this.constantYmd = changeDateFormat(this.value, 'YYYY-MM-DD');
      this.constantHms = changeDateFormat(this.value, 'HH:mm:ss');
    }
  }
  private async mounted() {
    await this.initOption();
    if (this.value === '' || this.value === null || this.value === undefined) {
      this.selecdYmd = '';
    } else {
      this.selecdYmd = changeDateFormat(this.value, 'YYYY-MM-DD');
    }
    const selectableRanges: [Date, Date][] = [[moment(this.calendarInfo.fromRanges).toDate(), moment(this.calendarInfo.toRanges).toDate()]]
    this.selectDatepicker = await new TuiDatePicker(`#selecdYmd_${this.calendarInfo.name}_layer`, {
      language: 'ko',
      date: moment(this.selecdYmd).toDate(),
      input: {
        element: `#selecdYmd_${this.calendarInfo.name}`,
        format: 'yyyy-MM-dd'
      },
      selectableRanges: selectableRanges
    });

    if (this.calendarInfo.endDate && this.selecdHms === '00:00:00') {
      this.selecdHms = '23:59:59';
    }
    this.selectDatepicker.on('change', (): void => {
      let changeed = true;
      if (typeof this.calendarInfo.checkDate === 'function') {
        changeed = this.calendarInfo.checkDate(getStrDate(this.selectDatepicker._date) + ' ' + this.selecdHms);
      }
      if (changeed) {
        this.selecdYmd = getStrDate(this.selectDatepicker._date);
      } else {
        this.selectDatepicker.setDate(moment(this.selecdYmd).toDate());
      }
    });
    this.selectDatepicker.on('open', (): void => {
      if (typeof this.calendarInfo.onOpen === 'function') {
        this.calendarInfo.onOpen();
      }
      $('#pop').show();

      // 팝업이 화면을 넘어가는 경우 위치 조정
      const popupElement = document.querySelector('.tui-datepicker') as HTMLDivElement;
      const rect = popupElement.getBoundingClientRect();

      if (rect.bottom > window.innerHeight) {
        popupElement.style.bottom = '24px';
      }
    });
    this.selectDatepicker.on('close', (): void => {
      if (typeof this.calendarInfo.onClose === 'function') {
        this.calendarInfo.onClose();
      }
      const popupElement = document.querySelector('.tui-datepicker') as HTMLDivElement;
      popupElement.style.bottom = 'unset';
      $('#pop').hide();
    });
    $('#wrap').on('click', '.tui-calendar-title-today', $.proxy(this.onClickToday, this));

    if (this.isImutableRendering) {
      this.setConstValueAfterMounting();
    }
  }
}
